<template lang="pug">
</template>
<script>
export default {
    name: 'ColSize',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        size() {
            let size = '50';
            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'colsize');
                if (setting && setting.value !== undefined) size = setting.value;
            }
            return size;
        }
    },
    mounted() {
        document.body.classList.add('colsize-' + this.size);
    },
    destroyed() {
        document.body.classList.remove('colsize-' + this.size);
    }
};
</script>
